import React, { useRef, useMemo } from "react";
import {
  NavigationLandingContainer,
  NavigationItem,
  NavigationImage,
} from "../styles/components/landing";

const LandingNavigation = ({ content }) => {
  const navigationItems = useRef([]);
  navigationItems.current = [];

  const setRef = el => {
    if (el && !navigationItems.current.includes(el)) {
      navigationItems.current.push(el);
    }
  };

  const componentContent = useMemo(() => {
    return Object.values(content).map(component => ({
      key: component.moduleTitle ? component.moduleTitle : component.key,
      content: component,
    }));
  }, [content]);

  const navigationComponent = componentContent.find(
    c => c.key === "component--navigation"
  );

  const navigationItemsContent = useMemo(() => {
    return navigationComponent?.content?.content ?? [];
  }, [navigationComponent]);

  const articleData = content.find(item => item.key === "article--data");
  const articleId = parseInt(articleData?.id);

  const showNavigation = articleData?.showNavigation === true;

  const navigationImages = useMemo(() => {
    return navigationItemsContent[0]?.images ?? [];
  }, [navigationItemsContent]);

  const filteredImages = useMemo(() => {
    if (!articleData) return [];

    const currentIndex = articleData.id;

    if (articleData.showNextArticle) {
      return navigationImages.slice(0, currentIndex + 2);
    }

    return navigationImages.slice(0, currentIndex + 1);
  }, [navigationImages, articleData]);

  return (
    <>
      {showNavigation && (
        <NavigationLandingContainer>
          {filteredImages &&
            filteredImages.map((item, index) => {
              const image = item?.image?.fluid?.src;
              const aspectRatio = item?.image?.fluid?.aspectRatio;
              const itemId = index + 1;
              const offsetX = 5;
              const offsetY = 30;

              const isActive = articleId === itemId;
              const baseZIndex = filteredImages.length - index;
              const zIndex = isActive ? filteredImages.length + 1 : baseZIndex;

              return (
                <NavigationItem
                  key={item.key || index}
                  id={`navigation-${index}`}
                  ref={setRef}
                  $isActive={isActive}
                  $x={-offsetX * index}
                  $y={offsetY * index}
                  $z={zIndex}
                >
                  <NavigationImage src={image} $aspectRatio={aspectRatio} />
                </NavigationItem>
              );
            })}
        </NavigationLandingContainer>
      )}
    </>
  );
};

export default LandingNavigation;
